import { FC } from 'react';

import { TrashOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

export const DeleteButton: FC<{ dataQa: string; onDelete: () => void }> = ({ dataQa, onDelete }) => {
    return (
        <TrashOutlinedSize24
            initialColor="secondary"
            highlightedColor="primary"
            backgroundStyle="secondary"
            borderRadius={12}
            padding={12}
            onClick={onDelete}
            data-qa={dataQa}
        />
    );
};
